<script lang="ts">
  import OVIcon from "$components/+blocks/OVIcon/OVIcon.svelte";
  import Image from "$components/+blocks/Image/Image.svelte";
  import api from "api";
  import { NodeViewWrapper } from "svelte-tiptap";
  import type { NodeViewProps } from "@tiptap/core";
  import GutterMenu from "$components/editor/extensions/+shared/GutterMenu.svelte";
  import { onMount } from "svelte";
  import { UA } from "$components/+blocks/OVIcon";

  export let node: NodeViewProps["node"];
  export let updateAttributes: NodeViewProps["updateAttributes"];
  export let deleteNode: NodeViewProps["deleteNode"];
  export let isEditable: boolean;
  $$restProps; // prevent svelte unused props warning

  // attributes defined in the TipTap config in ThreadBlock.ts
  let { url, openGraph, host } = node.attrs;

  let isImageVisible = true;

  async function fetchOpenGraphData() {
    // fetch only if not stored in the node
    if (openGraph) {
      return;
    }
    try {
      openGraph = (await api.opengraphExtract({ url })).data;
      // don't render block if no title, leave as link
      if (!openGraph.title) {
        throw new Error();
      }
      host = new URL(url).host.replace(/^www\./, "");
      updateAttributes({ host, openGraph });
    } catch (e) {
      deleteNode();
    }
  }

  onMount(() => {
    fetchOpenGraphData();
  });
</script>

<NodeViewWrapper>
  <div class="not-prose group relative pb-4">
    {#if openGraph}
      {#if isEditable}
        <GutterMenu on:delete-block={deleteNode} />
      {/if}
      <div class="flex gap-4">
        <div class="h-auto w-1 shrink-0 rounded-xl bg-gray-300 dark:bg-gray-500" />
        <a
          class="group-one flex max-w-[300px] flex-1 flex-col gap-3"
          href={url}
          target="_blank"
          rel="noreferrer"
        >
          <div class="flex flex-nowrap items-center justify-between gap-2">
            {#if host}
              <span class="shrink truncate font-semibold text-gray-700 dark:text-white">
                {host}
              </span>
            {/if}
            <OVIcon
              class="shrink-0 rotate-45 text-gray-500 opacity-0 transition-opacity duration-75 dark:text-gray-300 group-one-hover:opacity-100"
              icon={UA}
            />
          </div>
          {#if openGraph?.title}
            <span
              class="line-clamp-1 font-semibold text-community-primary underline-offset-2 group-one-hover:underline"
              >{openGraph.title}</span
            >
          {/if}

          {#if openGraph?.description}
            <span class="line-clamp-3 font-medium text-gray-500 dark:text-gray-300">
              {openGraph.description}
            </span>
          {/if}
          {#if isImageVisible && openGraph?.image}
            <Image
              on:error={() => (isImageVisible = false)}
              src={openGraph.image[0]}
              fallback
              class="aspect-[1.95] w-full rounded-lg bg-gray-200 dark:bg-gray-200/20"
              cropPosition={null}
              alt={openGraph.title || ""}
            />
          {/if}
        </a>
      </div>
    {/if}
  </div>
</NodeViewWrapper>
